import React, { useEffect } from "react";
import "./Home.css";
import Aos from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
import node from "../../icons/node.png";
import express from "../../icons/express.png";
import js from "../../icons/js.png";
import mongo from "../../icons/mongo.png";
import html from "../../icons/html.png";
import css from "../../icons/css.png";
import react from "../../icons/react.png";
import clang from "../../icons/c++.png";
import instagram from "../../icons/instagram.png";
import github from "../../icons/github.png";
import linkedin from "../../icons/linkedin.png";
import telegram from "../../icons/telegram.png";
import twitter from "../../icons/twitter.png";
import projectList from "../Projects/Projectlist";
import DataList from "../Home/DataList";

const Instagram = "https://www.instagram.com/_jatul_/";
const Github = "https://github.com/JatulCodes";
const Linkdin = "https://www.linkedin.com/in/jatul-kumar-b977061a2/";
const Tweeter = "https://twitter.com/Jatul13";

// import "../Buttons/buttons.css";
const Home = () => {
	useEffect(() => {
		Aos.init();
	}, []);
	return (
		<>
			<div className="Home">
				<div
					className="socialMediaIcon"
					data-aos="fade-right"
					data-aos-duration="2000"
				>
					<Link to={Instagram}>
						<img src={instagram} alt="img" />
					</Link>
					<Link to={Linkdin}>
						<img src={linkedin} alt="img" />
					</Link>
					<Link to={Github}>
						<img src={github} alt="img" />
					</Link>
					<Link to={Tweeter}>
						<img src={twitter} alt="img" />
					</Link>
					<Link to="#">
						<img src={telegram} alt="img" />
					</Link>
				</div>

				<a href="#section2" className="downArow">
					<p> &#8595; </p>
				</a>
				{/* <img src="../../Images/homebg.jpg" alt="" /> */}
				<div className="homecanvas">
					<div className="centerText">
						<h2 className="heading1">I'Am</h2>
						<h1 className="heading2">jatul kumar</h1>
						<p className="heading3">
							I help compnies to make beautiful websites
						</p>
						<p className="heading4">Fullstack developer</p>

						<Link to="/about" className="button1">
							Explore Now &#8594;
						</Link>
						<Link
							to="https://drive.google.com/file/d/1FvNztdY8I1WIC4nfbm9Y3etbSvGLVGA3/view?usp=sharing"
							className="button1"
						>
							Hire Me &#8594;
						</Link>
					</div>
					<div className="rightSideImg">
						<img
							src="../../Images/DrawKit Vector Illustration Team Work (9).png"
							alt=""
						/>
					</div>
				</div>
				<div className="section2" id="section2">
					<div className="centerDiv">
						<h2
							className="heading"
							data-aos="fade-down"
							data-aos-duration="2000"
						>
							Little About Me
						</h2>
						{DataList.map((item) => {
							return (
								<p
									className="paragrap"
									data-aos="fade-up"
									data-aos-duration="2000"
								>
									{item.LittleAboutMe}
								</p>
							);
						})}
					</div>
				</div>
				<div className="skillsSections">
					<h2
						className="SkillHeading"
						data-aos="fade-right"
						data-aos-duration="800"
					>
						Skills
					</h2>
					<div
						className="iconsSkills"
						// data-aos="fade-left"
						// data-aos-duration="2000"
					>
						<div
							className="Cards"
							data-aos="fade-down"
							data-aos-duration="1000"
						>
							<img src={node} alt="icon" />
						</div>

						<div className="Cards" data-aos="fade-up" data-aos-duration="2000">
							<img src={express} alt="icon" />
						</div>
						<div
							className="Cards"
							data-aos="fade-right"
							data-aos-duration="1500"
						>
							<img src={js} alt="icon" />
						</div>
						<div
							className="Cards"
							data-aos="fade-left"
							data-aos-duration="1800"
						>
							<img src={mongo} alt="icon" />
						</div>
						<div
							className="Cards"
							data-aos="fade-down"
							data-aos-duration="2000"
						>
							<img src={html} alt="icon" />
						</div>
						<div className="Cards" data-aos="fade-up" data-aos-duration="2300">
							<img src={css} alt="icon" />
						</div>
						<div
							className="Cards"
							data-aos="fade-right"
							data-aos-duration="2500"
						>
							<img src={react} alt="icon" />
						</div>
						<div className="Cards" data-aos="fade-up" data-aos-duration="2000">
							<img src={clang} alt="icon" />
						</div>
					</div>
				</div>
				{/* <section className="abhipatanahi"></section> */}
			</div>
		</>
	);
};

export default Home;
